import React, {Component, Fragment} from 'react'
import {Form, Input, Table, Button, Radio, Row, Col, message, Checkbox, Select} from 'antd';
import SpaceModel from './preview/spaceModel'
import CabinetTypeSelect from "../../components/cabinet-type-select";
import {
    reqCabin, getOrderShort, getPackages, reqAddress, baseUrl, reqArea, reqRentalBox, reqDeclareCities,
    reqGetSuppliers,
} from '../../api';
import SelectAreaFormItem from './select-area'
import SelectFormItem from '../../components/select-form-item'
import {handleChangeArea, handleChangeRentalBox,} from '../../utills/common';
import {getUserInfo} from "../../utills/userUtils";
import moment from "moment";
import "moment/locale/zh-cn";
import {
    DELIVERY_TYPE, DELIVERY_TYPE_MIX, DELIVERY_TYPE_HIGHWAY, DELIVERY_TYPE_AIR, SUB_TYPE,
    TRANSFER_TYPE_N, TRANSFER_TYPE_D, TRANSFER_TYPE_T, TRANSFER_TYPE_A,
} from "../../utills/constants";
import {convertToRadios} from "../../components/radios";
moment.locale('zh-cn');
let orderId;
class OrderSpaceView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            previewData: {},  // 预览数据
            cabinPackageVoList: [],
            previewVisiable: false,
            formLayout: 'horizontal',
            cabin: [],
            shipper: [],
            consignee: [],
            origin: [],
            destination: [],
            intiCityValue: '阿拉山口',
            intiCountryValue: '中国',
            rentBox: [],
            returnBox: [],
            supplierList: [],
        };
    }

    componentDidMount() {
        orderId = this.props.location.state.orderId;
        getUserInfo().then((userInfo) => {
            this.setState({
                userSupplierCode: userInfo.supplierCode,
            }, function () {
                this.getCabin(orderId);
            })
        });
        this.goods(orderId);
        this.getAddress(4);
        this.getAddress(5);
        this.getDeclareCities();
    }

    judgeReadOnly = orderStatus => {
        return true;
    };
    getCabin = async (orderId) => {
        const {setFieldsValue} = this.props.form;
        const result = await getOrderShort(orderId);
        if (result.code === 200) {
            this.setInitAreaData(result.data.originCity, "F");
            this.setInitAreaData(result.data.destinationCity, "T");
            if (DELIVERY_TYPE_MIX.hasOwnProperty(result.data.deliveryType)) {
                this.setInitAreaData(result.data.internationalEndCity, "D");
                if (result.data.deliveryType === 'D') {
                    this.setInitAreaData(result.data.airStartCity, "FS");
                }
            } else if (DELIVERY_TYPE_HIGHWAY.hasOwnProperty(result.data.deliveryType)) {
                this.setInitAreaData(result.data.customsClearanceCity, "C");
            } else {
                this.setInitAreaData(result.data.customsClearanceCity, "C");
                this.setInitAreaData(result.data.airStartCity, 'AF');
                this.setInitAreaData(result.data.internationalEndCity, 'AT');
            }
            this.setInitRentalBoxData(result.data.boxRentStation, "rent_box");
            this.setInitRentalBoxData(result.data.boxReturnStation, "return_box");
            //转关运输时，设置报关地必填
            this.handleDeclareMode(result.data.declareMode);
            //供应商
            const supplier = {};
            const supplierList = [];
            result.data.supplierList.forEach((o, i) => {
                if (o.indx == null || o.indx == -2) {
                    if (this.state.userSupplierCode === o.supplierCode) {
                        supplier[o.supplierType] = o.supplierName;
                    }
                }
                if (o.indx != null) {
                    const supplierType = this.getSupplierTypeValue(o.indx, o.supplierType, result.data.deliveryType, i === result.data.supplierList.length - 1);
                    o.supplierType = supplierType;
                    supplierList.push(o);
                    this.setState({
                        ['supplierType' + o.indx]: supplierType,
                        ['supplier' + o.indx]: this.state[supplierType],
                    });
                }
            });
            delete result.data.supplierList;
            setFieldsValue(supplier);
            this.setState({
                readOnly: this.judgeReadOnly(result.data.orderStatus),
                ...result.data, supplierList,
            }, () => {
                this.handleTransferType(result.data.transferType)
            });
        } else if (result.code === 401) {
            message.error(result.message)
        }

    };
    setInitAreaData = async (city, type) => {
        let result = await reqArea(type);
        if (result.code === 200) {
            let preInit;
            if (type === 'F') {
                preInit = city ? city : result.data[0].cityName;
                handleChangeArea(this, 'originCity', preInit, 'originCountry', 'origin', result.data)
            } else if (type === 'T') {
                preInit = city ? city : result.data[0].cityName;
                handleChangeArea(this, 'destinationCity', preInit, 'destinationCountry', 'destination', result.data);
            } else if (type === 'FS') {//起始站：亚欧直达
                preInit = city ? city : result.data[0].cityName;
                handleChangeArea(this, 'airStartCity', preInit, 'airStartCountry', 'start', result.data);
            } else if (type === 'D') {
                preInit = city ? city : result.data[0].cityName;
                handleChangeArea(this, 'internationalEndCity', preInit, 'internationalEndCountry', 'international', result.data);
            } else if (type === 'C') {
                preInit = city ? city : result.data[0].cityName;
                handleChangeArea(this, 'customsClearanceCity', preInit, 'customsClearanceCountry', 'customsClearance', result.data);
            } else if (type === 'AF') {//启运机场
                preInit = city ? city : result.data[0].cityName;
                handleChangeArea(this, 'airStartCity', preInit, 'airStartCountry', 'airStart', result.data);
            } else if (type === 'AT') {//目的机场
                preInit = city ? city : result.data[0].cityName;
                handleChangeArea(this, 'airEndCity', preInit, 'airEndCountry', 'airEnd', result.data);
            }
        } else {
            message.error(result.message);
        }
    };
    //租箱地rent_box,还箱地return_box
    setInitRentalBoxData = async (stationValue, type) => {
        let result = await reqRentalBox(type);
        if (result.code === 200) {
            if (type === 'rent_box') {
                handleChangeRentalBox(this, 'boxRentStation', stationValue, 'rentBox', result.data)
            }
            else if (type === 'return_box') {
                handleChangeRentalBox(this, 'boxReturnStation', stationValue, 'returnBox', result.data);
            }
        } else {
            message.error(result.message);
        }
    };
    handleDeclareMode = (value) => {
        let declareCityRequired = false;
        let declareSupplierRequired = false;
        if (value === '转关运输') {
            declareCityRequired = true;
        }
        if (value !== '9610') {
            declareSupplierRequired = true;
        }
        this.setState({declareCityRequired, declareSupplierRequired})
    }
    goods = async (orderId, page = 1, pageSize = 20) => {
        let result = await getPackages({orderId, pageNum: page, pageSize});
        if (result.code === 200) {
            if (result.data) {
                result.data.rows.map((o, index) => {
                    o.key = index + 1;
                    if (!o.ifPlan) {
                        o.ifPlan = 'N';
                    }
                });
                this.setState({
                    page,
                    pageSize,
                    total: result.data.total,
                    cabinPackageVoList: result.data.rows,
                })
            }
        }
        else {
            message.error(result.message);
            return false;
        }
    };
    serviceAreaOnChange = e => {
        this.setState({
            serviceArea: e.target.value,
        });
    };
    boxTypeOnChange = e => {
        this.setState({
            boxType: e.target.value,
        });
    };
    declareTypeOnChange = e => {
        this.setState({
            declareType: e.target.value,
        });
    };
    clearTypeOnChange = e => {
        this.setState({
            clearType: e.target.value,
        });
    };
    deliveryMethodOnChange = e => {
        this.setState({
            deliveryMethod: e.target.value,
        });
    };
    getAddress = async (type) => {
        const result = await reqAddress(type);
        if (result.code === 200) {
            if (type == 4) {
                this.setState({cabin: result.data})
            }
            if (type == 5) {
                this.setState({shipper: result.data})
            }
            if (type == 6) {
                this.setState({consignee: result.data})
            }
        }
    };
    //下载PDF
    downloadPdf = () => {
        var name = "cabin";
        orderId = this.props.location.state.orderId;
        if (orderId != null && orderId != "") {
            window.location.href = baseUrl + "/api/v1/p/file/fileDownload?id=" + orderId + "&name=" + name;
        } else {
            message.error("该订舱单不存在,请先保存订舱单")
        }
    };

    // 预览弹框//显示弹窗
    previewShowModal = () => {
        const previewData = this.state
        console.log(previewData)
        this.setState({
            previewVisiable: true,
            previewData: previewData
        });
    };
    //取消弹窗
    previewhideModal = () => {
        this.setState({
            previewVisiable: false,
        })
    };
    getDeclareCities = async () => {
        let result = await reqDeclareCities();
        if (result.code === 200) {
            this.setState({
                declareCities: [...result.data],
            })
        } else {
            message.error(result.message)
        }
    }
    getSuppliers = async (type) => {
        let result = await reqGetSuppliers(type)
        if (result.code === 200) {
            this.setState({
                [type]: [...result.data],
            })
        } else {
            message.error(result.message)
        }
    };
    handleTransferType = (value) => {
        const form = this.props.form;
        let firstOn = false;//indx=-2
        let negativeOneOn = true;//出境口岸indx=-1
        let zeroOn = true;//启运机场indx=0
        let lastOn = false;
        if (value === 'w2w' || value === 'w2s' || value === 'w2p' || value === 'w2a' || value === 'w2as') {
            firstOn = true;
        }
        if (value === 'w2p' || value === 'p2p') {
            negativeOneOn = false;
        }
        if (value === 'w2as' || value === 'p2as' || value === 'p2p') {
            zeroOn = false;
        }
        if (value === 's2w' || value === 'w2w' || value === 'p2w') {
            lastOn = true;
        }
        this.setState({firstOn, negativeOneOn, zeroOn, lastOn, transferType: value,});
        //切换时，供应商清空
        if (!firstOn) {
            form.setFieldsValue({oriHighway: ''})
        }
        if (!negativeOneOn) {
            form.setFieldsValue({['supplierCode-1']: ''})
        }
        if (!zeroOn) {
            form.setFieldsValue({['supplierCode0']: ''})
        }
        if (!lastOn) {
            const {supplierList} = this.state;
            const o = supplierList[supplierList.length - 1];
            form.setFieldsValue({['supplierCode' + o.indx]: ''})
        }
    };
    getSupplierTypeValue = (indx, supplierType, deliveryType, ifLast = false) => {
        let supplierTypeValue = supplierType;
        if (!supplierTypeValue) {
            //既有公路又有铁路
            if (DELIVERY_TYPE_MIX.hasOwnProperty(deliveryType)) {
                if (indx == '-2') {
                    supplierTypeValue = 'oriHighway';//国内公路
                }
                if (indx == '-1') {
                    supplierTypeValue = 'railway';//国际铁路
                    if (deliveryType === 'D') {
                        supplierTypeValue = 'highway';//国际公路
                    }
                }
                if (indx >= 0) {
                    supplierTypeValue = 'eurRailway';//欧洲铁路
                }
            }
            //只有公路
            if (DELIVERY_TYPE_HIGHWAY.hasOwnProperty(deliveryType)) {
                if (indx == '-2') {
                    supplierTypeValue = 'oriHighway';//国内公路
                }
                if (indx == '-1') {
                    supplierTypeValue = 'highway';//国际公路
                }
                if (indx > 0) {
                    supplierTypeValue = 'eurHighway';//欧洲公路
                }
            }
            //含空运
            if (DELIVERY_TYPE_AIR.hasOwnProperty(deliveryType)) {
                if (indx == '-2') {
                    supplierTypeValue = 'oriHighway';//国内公路
                }
                if (indx == '-1') {
                    supplierTypeValue = 'highway';//国际公路
                }
                if (indx >= 0) {
                    supplierTypeValue = 'air';//空运
                }
                if (ifLast) {//最后一个
                    supplierTypeValue = 'eurHighway';//欧洲公路
                }
            }
        }
        return supplierTypeValue
    };

    render() {
        const {
            page, pageSize, total, cabinPackageVoList, deliveryType, subType, transferType, supplierList,
            firstOn, negativeOneOn, zeroOn, lastOn, userSupplierCode, readOnly
        } = this.state;
        const {getFieldDecorator, getFieldValue, setFieldsValue} = this.props.form;
        const formItemLayout = {
            labelCol: {span: 9},
            wrapperCol: {span: 14}
        };
        const formItemLayout2 = {
            labelCol: {span: 8},
            wrapperCol: {span: 16}
        };
        const columns = [
            {
                title: '唛码标记Marks',
                dataIndex: 'boxNo',
            }, {
                title: '品名(中文)',
                dataIndex: 'name',
            }, {
                title: '品名(英文)',
                dataIndex: 'nameEn',
            }, {
                title: '国内HSCode',
                dataIndex: 'hscode',
            }, {
                title: '国外HSCode',
                dataIndex: 'oHscode',
            }, {
                title: '箱数CTNS',
                dataIndex: 'num',
            }, {
                title: '件数PCS',
                dataIndex: 'pcsNumber',
            }, {
                title: '毛重(Kg)',
                dataIndex: 'grossWeight',
            }, {
                title: '净重(Kg)',
                dataIndex: 'netWeight',
            }, {
                title: '体积(CBM)',
                dataIndex: 'volume',
            }, {
                title: '单价/币制Value unit',
                dataIndex: 'originalValue',
                render: (text, record) => {
                    if (text != null) {
                        return text + '/' + record.originalCurrency;
                    }
                }
            }, {
                title: '总价/币制Value & Currency',
                dataIndex: 'originalTotalValue',
                render: (text, record) => {
                    if (text != null) {
                        return text + '/' + record.originalCurrency;
                    }
                }
            }, {
                title: '成分',
                dataIndex: 'ingredient',
            }, {
                title: '用途',
                dataIndex: 'application',
            }, {
                title: '是否需要装箱方案',
                dataIndex: 'ifPlan',
                render: (text) => {
                    if (text === 'N') {
                        return '否';
                    } else if (text === 'Y') {
                        return '是';
                    } else {
                        return '';
                    }
                }
            }];
        const sup = supplierList.length - 1;
        const circles = (supplierList || []).map((o, i) => {
            if (o.indx < 0) {
                if (o.indx == -2) {
                    return <span>
                    <div className={'circle' + (firstOn ? ' circle-on' : '')}></div>
                    <div className={'line' + (firstOn ? ' line-on' : '')}>
                        {DELIVERY_TYPE_MIX.hasOwnProperty(deliveryType) ?
                            <select name={'supplierType' + o.indx} disabled={true}>
                                <option value='oriHighway' selected={o.supplierType == 'oriHighway'}>公路</option>
                            </select> : null
                        }
                    </div>
                </span>
                } else {
                    return <span>
                    <div className="circle circle-on"></div>
                  <div className={'line' + (negativeOneOn ? ' line-on' : '')}>
                          {DELIVERY_TYPE_MIX.hasOwnProperty(deliveryType) ?
                              <select name={'supplierType' + o.indx} onChange={this.handleRoad}
                                      disabled={readOnly || deliveryType === 'D'}>
                                  {deliveryType !== 'D' ?
                                      <option value='railway' selected={o.supplierType == 'railway'}>铁路</option> : null}
                                  <option value='highway' selected={o.supplierType == 'highway'}>公路</option>
                              </select> : null
                          }
                    </div>
                </span>
                }
            }
            if (o.indx === 0) {
                return <Fragment>
                    <div className={'circle' + (negativeOneOn ? ' circle-on' : '')}></div>
                    <div className={'line' + (zeroOn ? ' line-on' : '')}>
                        {deliveryType === 'D' ?
                            <select name={'supplierType' + o.indx} onChange={this.handleRoad}
                                    disabled={readOnly}>
                                <option value='eurRailway' selected={o.supplierType == 'eurRailway'}>铁路</option>
                                <option value='eurHighway' selected={o.supplierType == 'eurHighway'}>公路</option>
                            </select> : null
                        }
                    </div>
                </Fragment>
            }
            if (o.indx > 0) {
                return <span>
                  <div className={'circle' + (zeroOn ? ' circle-on' : '')}></div>
                    <div className={'line' + ((sup === i && lastOn || sup !== i) ? ' line-on' : '')}>
                        {DELIVERY_TYPE_MIX.hasOwnProperty(deliveryType) ?
                            <select name={'supplierType' + o.indx} onChange={this.handleRoad}
                                    disabled={readOnly}>
                                <option value='eurRailway' selected={o.supplierType == 'eurRailway'}>铁路</option>
                                <option value='eurHighway' selected={o.supplierType == 'eurHighway'}>公路</option>
                            </select> : null
                        }
                    </div>
                </span>
            }
        });
        const formItems = (supplierList || []).map((o, i) => {
            if (o.indx == -1) {
                return <Row>
                    <Col span={12}>
                        <SelectFormItem
                            layout={formItemLayout2}
                            label='供应商'
                            name={['supplierCode' + o.indx]}
                            getFieldDecorator={getFieldDecorator}
                            initialValue={userSupplierCode === o.supplierCode ? o.supplierName : ''}
                            initialValueNull={true}
                            data={this.state['supplier' + o.indx]}
                            dataValue='supplierCode'
                            dataContent='supplierName'
                            disabledOpt={readOnly || !negativeOneOn}
                        />
                    </Col>
                    {(readOnly || DELIVERY_TYPE_MIX.hasOwnProperty(deliveryType) || DELIVERY_TYPE_AIR.hasOwnProperty(deliveryType) || transferType == 'p2p' || transferType == 'w2p') ? null :
                        <Col span={12}>
                            <Button size='small' className='position-btn' onClick={this.addPosition}>添加节点</Button>
                        </Col>}
                </Row>
            }
            if (o.indx == 0) {
                return <Fragment>
                    {DELIVERY_TYPE_AIR.hasOwnProperty(deliveryType) ?
                        <Row>
                            <Col span={12}>
                                <SelectAreaFormItem
                                    layout={formItemLayout2}
                                    label='启运机场'
                                    name={['position' + o.indx]}
                                    getFieldDecorator={getFieldDecorator}
                                    initialValue={o.position}
                                    disabledOpt={readOnly}
                                    data={this.state.airStart}/>
                            </Col>
                            {readOnly || transferType === 'w2as' || transferType === 'p2as' || transferType === 'p2p' ? null :
                                <Col span={12}>
                                    <Button size='small' className='position-btn'
                                            onClick={this.addPosition}>添加节点</Button>
                                </Col>}
                        </Row> :
                        <Row>
                            <Col span={12}>
                                <SelectAreaFormItem
                                    layout={formItemLayout2}
                                    label='起始站'
                                    name={['position' + o.indx]}
                                    getFieldDecorator={getFieldDecorator}
                                    initialValue={o.position}
                                    disabledOpt={readOnly}
                                    data={this.state.start}/>
                            </Col>
                        </Row>}
                    <Row>
                        <Col span={12}>
                            <SelectFormItem
                                layout={formItemLayout2}
                                label='供应商'
                                name={['supplierCode' + o.indx]}
                                getFieldDecorator={getFieldDecorator}
                                initialValue={userSupplierCode === o.supplierCode ? o.supplierName : ''}
                                initialValueNull={true}
                                data={this.state['supplier' + o.indx]}
                                dataValue='supplierCode'
                                dataContent='supplierName'
                                disabledOpt={readOnly || !zeroOn}
                            />
                        </Col>
                    </Row>
                </Fragment>
            }
            if (o.indx > 0) {
                return <Fragment>
                    {DELIVERY_TYPE_AIR.hasOwnProperty(deliveryType) ?
                        <Row>
                            <Col span={12}>
                                <SelectAreaFormItem
                                    layout={formItemLayout2}
                                    label={i === supplierList.length - 1 ? '目的机场' : '机场'}
                                    name={['position' + o.indx]}
                                    getFieldDecorator={getFieldDecorator}
                                    initialValue={o.position}
                                    disabledOpt={readOnly}
                                    data={this.state.airEnd}
                                />
                            </Col>
                            <Col span={12}>
                                {readOnly || i === supplierList.length - 1 ? null :
                                    <Fragment>
                                        <Button size='small' className='position-btn'
                                                onClick={this.addPosition}>添加节点</Button>
                                        <Button size='small' className='position-btn'
                                                onClick={() => this.delPosition(o.indx)}>删除节点</Button>
                                    </Fragment>}
                            </Col>
                        </Row> :
                        <Row>
                            <Col span={12}>
                                <SelectAreaFormItem
                                    layout={formItemLayout2}
                                    label={DELIVERY_TYPE_MIX.hasOwnProperty(deliveryType) ? '铁路站' : '公路站' }
                                    name={['position' + o.indx]}
                                    getFieldDecorator={getFieldDecorator}
                                    initialValue={o.position}
                                    disabledOpt={readOnly}
                                    data={this.state.international}
                                />
                            </Col>
                            <Col span={12}>
                                {readOnly ? null :
                                    <Fragment>
                                        {transferType == 'p2p' || transferType == 'w2p' ? null :
                                            <Button size='small' className='position-btn'
                                                    onClick={this.addPosition}>添加节点</Button>}
                                        {DELIVERY_TYPE_MIX.hasOwnProperty(deliveryType) && o.indx == 1 ? null :
                                            <Button size='small' className='position-btn'
                                                    onClick={() => this.delPosition(o.indx)}>删除节点</Button>}</Fragment>}
                            </Col>
                        </Row>}
                    <Row>
                        <Col span={12}>
                            <SelectFormItem
                                layout={formItemLayout2}
                                label='供应商'
                                name={['supplierCode' + o.indx]}
                                getFieldDecorator={getFieldDecorator}
                                initialValue={userSupplierCode === o.supplierCode ? o.supplierName : ''}
                                initialValueNull={true}
                                data={this.state['supplier' + o.indx]}
                                dataValue='supplierCode'
                                dataContent='supplierName'
                                disabledOpt={readOnly || (sup === i && !lastOn)}
                            />
                        </Col>
                    </Row>
                </Fragment>
            }
        });
        return (
            <Form layout={this.state.formLayout} className='order-space'{...formItemLayout}>
                <div className="order-base-title">
                    基本信息
                </div>
                <div className="order-spaceInfo-content">
                    <span><span>委托类型:</span></span>
                    <div className='route-planning'>
                        <Row>
                            <Col span={24}>
                                <Form.Item label="运输类型" {...{
                                    labelCol: {span: 3},
                                    wrapperCol: {span: 21}
                                }}>
                                    {getFieldDecorator('deliveryType', {
                                        initialValue: deliveryType,
                                        rules: [{required: true, message: '该项必填'}]
                                    })(<Radio.Group disabled={readOnly}>
                                        {convertToRadios(DELIVERY_TYPE)}
                                    </Radio.Group>)}
                                </Form.Item>
                            </Col>
                            {DELIVERY_TYPE_HIGHWAY.hasOwnProperty(deliveryType) && deliveryType !== 'M' ?
                                <Col span={24}>
                                    <Form.Item label="服务模式"{...{
                                        labelCol: {span: 3},
                                        wrapperCol: {span: 21}
                                    }}>
                                        {getFieldDecorator('subType', {
                                            initialValue: subType,
                                            rules: [{required: true, message: '该项必填'}]
                                        })(<Radio.Group disabled={readOnly}
                                                        onChange={e => this.setState({subType: e.target.value})}>
                                            {convertToRadios(SUB_TYPE)}
                                        </Radio.Group>)}
                                    </Form.Item>
                                </Col> : null}
                        </Row>
                        <Row>
                            <Col span={24}>
                                <Form.Item label="委托方式"{...{
                                    labelCol: {span: 3},
                                    wrapperCol: {span: 21}
                                }}>
                                    {getFieldDecorator('transferType', {
                                        initialValue: transferType,
                                        rules: [{required: true, message: '该项必填'}]
                                    })(<Radio.Group disabled={readOnly}
                                                    onChange={e => this.handleTransferType(e.target.value)}>
                                        {DELIVERY_TYPE_MIX.hasOwnProperty(deliveryType) && deliveryType !== 'D' ?
                                            <Fragment>{convertToRadios(TRANSFER_TYPE_N)}</Fragment> : null}
                                        {deliveryType === 'D' ?
                                            <Fragment>{convertToRadios(TRANSFER_TYPE_D)}</Fragment> : null}
                                        {DELIVERY_TYPE_HIGHWAY.hasOwnProperty(deliveryType) ?
                                            <Fragment>{convertToRadios(TRANSFER_TYPE_T)}</Fragment> : null}
                                        {DELIVERY_TYPE_AIR.hasOwnProperty(deliveryType) ?
                                            <Fragment>{convertToRadios(TRANSFER_TYPE_A)}</Fragment> : null}
                                    </Radio.Group>)}
                                </Form.Item>
                            </Col>
                        </Row>
                    </div>
                    <span><span>线路规划:</span></span>
                    <div className='route-planning'>
                        <div className="column2">
                            <div className="circle-line">
                                {circles}
                                <div className={'circle' + (lastOn ? ' circle-on' : '')}></div>
                            </div>
                        </div>
                        <div className="column3">
                            <Row>
                                <Col span={12}>
                                    <SelectAreaFormItem
                                        layout={formItemLayout2}
                                        label='起运地'
                                        name="originCity"
                                        getFieldDecorator={getFieldDecorator}
                                        initialValue={this.state.originCity}
                                        handleChange={e => {
                                            handleChangeArea(this, 'originCity', e, 'originCountry', 'origin', null, 'boxRentStation')
                                        }}
                                        disabledOpt={readOnly}
                                        data={[...this.state['origin']]}
                                    /></Col>
                            </Row>
                            <Row>
                                <Col span={12}>
                                    <SelectFormItem
                                        layout={formItemLayout2}
                                        label='供应商'
                                        name="oriHighway"
                                        getFieldDecorator={getFieldDecorator}
                                        initialValueNull={true}
                                        data={this.state.oriHighway}
                                        dataValue='supplierCode'
                                        dataContent='supplierName'
                                        disabledOpt={readOnly}
                                    /></Col>
                            </Row>
                            <Row>
                                <Col span={12}>
                                    <SelectFormItem
                                        layout={formItemLayout2}
                                        label={deliveryType === 'X' ? '起始站' : '出境口岸'}
                                        name="customsPortName"
                                        getFieldDecorator={getFieldDecorator}
                                        initialValue={this.state.customsPortName}
                                        required={true}
                                        disabledOpt={this.state.readOnly}
                                    /></Col>
                                <Col span={12}>
                                    <SelectFormItem
                                        layout={formItemLayout2}
                                        label='制单方'
                                        name="noteSupplier"
                                        initialValue={userSupplierCode === this.state.noteSupplier ? this.state.noteSupplierName : ''}
                                        getFieldDecorator={getFieldDecorator}
                                        required={true}
                                        data={this.state.note}
                                        dataValue='supplierCode'
                                        dataContent='supplierName'
                                        disabledOpt={readOnly}
                                    /></Col>
                            </Row>
                            {formItems}
                            <Row>
                                <Col span={12}>
                                    <SelectAreaFormItem
                                        layout={formItemLayout2}
                                        label='目的仓'
                                        name="destinationCity"
                                        getFieldDecorator={getFieldDecorator}
                                        initialValue={this.state.destinationCity}
                                        disabledOpt={readOnly}
                                        data={this.state.destination}
                                        handleChange={e => {
                                            handleChangeArea(this, 'destinationCity', e, 'destinationCountry', 'destination', null, 'boxReturnStation')
                                        }}
                                    />
                                </Col>
                                <Col span={12}>
                                    {DELIVERY_TYPE_HIGHWAY.hasOwnProperty(deliveryType) || DELIVERY_TYPE_AIR.hasOwnProperty(deliveryType) ?
                                        <SelectAreaFormItem
                                            layout={formItemLayout2}
                                            label='清关地'
                                            name="customsClearanceCity"
                                            getFieldDecorator={getFieldDecorator}
                                            initialValue={this.state.customsClearanceCity}
                                            disabledOpt={readOnly}
                                            data={this.state.customsClearance}
                                            handleChange={e => {
                                                handleChangeArea(this, 'customsClearanceCity', e, 'customsClearanceCountry', 'customsClearance')
                                            }}
                                        /> : null}
                                </Col>
                            </Row>
                        </div>
                    </div>
                    <span><span>其他信息:</span></span>
                    <div className='spaceInfo-content-info'>
                        {DELIVERY_TYPE_MIX.hasOwnProperty(deliveryType) || (DELIVERY_TYPE_HIGHWAY.hasOwnProperty(deliveryType) && subType === 'A') ?
                            <Row>
                                <Col span={8}>
                                    <SelectFormItem
                                        label='租箱地'
                                        name="boxRentStation"
                                        getFieldDecorator={getFieldDecorator}
                                        initialValue={this.state.boxRentStation}
                                        initialValueNull={true}
                                        required={true}
                                        disabledOpt={readOnly}
                                        data={this.state.rentBox}
                                        dataValue='content'
                                        handleChange={e => {
                                            handleChangeRentalBox(this, 'boxRentStation', e, 'rentBox')
                                        }}
                                    />
                                </Col>
                                <Col span={8}>
                                    <SelectFormItem
                                        label='还箱地'
                                        name="boxReturnStation"
                                        getFieldDecorator={getFieldDecorator}
                                        initialValue={this.state.boxReturnStation}
                                        initialValueNull={true}
                                        required={true}
                                        disabledOpt={readOnly}
                                        data={this.state.returnBox}
                                        dataValue='content'
                                        handleChange={e => {
                                            handleChangeRentalBox(this, 'boxReturnStation', e, 'returnBox')
                                        }}
                                    />
                                </Col>
                                <Col span={8}>
                                    <Form.Item label="集装箱数">
                                        {getFieldDecorator('containerNum', {
                                            initialValue: this.state.containerNum,
                                            rules: [{required: true, message: '请填写箱型数量'}]
                                        })(<Input placeholder='集装箱数'
                                                  onChange={e => {
                                                      this.setState({containerNum: e.target.value})
                                                  }}
                                                  readOnly={readOnly}
                                                  addonAfter={<CabinetTypeSelect
                                                      deliveryType={deliveryType}
                                                      subType={subType}
                                                      initialValue={this.state.cabinetType}
                                                      getFieldDecorator={getFieldDecorator}
                                                      setFieldsValue={setFieldsValue}
                                                      disabled={readOnly}/>}
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row> : null}
                        <Row>
                            <Col span={8}>
                                <Form.Item label="货物类型">
                                    {this.state.declareModeName}
                                </Form.Item>
                            </Col>
                            {this.state.declareCityRequired ?
                                <Col span={8}>
                                    <SelectFormItem
                                        label='报关地'
                                        name="declareCity"
                                        getFieldDecorator={getFieldDecorator}
                                        initialValue={this.state.declareCity}
                                        required={this.state.declareCityRequired}
                                        data={this.state.declareCities}
                                        dataValue='declareCity'
                                        dataContent='declareCityName'
                                        disabledOpt={readOnly}
                                    />
                                </Col> : null}
                            {DELIVERY_TYPE_MIX.hasOwnProperty(deliveryType) ?
                                <Col span={8}>
                                    <SelectFormItem
                                        label='租箱供应商'
                                        name="boxRentSupplier"
                                        getFieldDecorator={getFieldDecorator}
                                        initialValue={userSupplierCode === this.state.boxRentSupplier ? this.state.boxRentSupplierName : ''}
                                        initialValueNull={true}
                                        required={true}
                                        data={this.state.boxRent}
                                        dataValue='supplierCode'
                                        dataContent='supplierName'
                                        disabledOpt={readOnly}
                                    />
                                </Col> : null}
                            {DELIVERY_TYPE_HIGHWAY.hasOwnProperty(deliveryType) && deliveryType === 'A' ?
                                <Col span={8}>
                                    <SelectFormItem
                                        label='租箱供应商'
                                        name="boxRentSupplier"
                                        getFieldDecorator={getFieldDecorator}
                                        initialValue={userSupplierCode === this.state.boxRentSupplier ? this.state.boxRentSupplierName : ''}
                                        initialValueNull={true}
                                        data={this.state.boxRent}
                                        dataValue='supplierCode'
                                        dataContent='supplierName'
                                        disabledOpt={readOnly}
                                    />
                                </Col> : null}
                        </Row>
                    </div>
                </div>
                <div className="order-base-title">国内仓库信息</div>
                <div className="space-base-content">
                    <div className="base-info" style={{height: 'auto'}}>
                        <Row>
                            <Col span={12}>
                                <span className='title'>仓库地址 : </span>
                                <span className='address-detail'>{this.state.deliveryPlace}</span>
                            </Col>
                            <Col span={12}>
                                <span className='title'>预计提货时间:</span>
                                <span
                                    className='address-detail'>{this.state.deliveryEstimateDt ? this.state.deliveryEstimateDt.substr(0, 13) : ''}</span>
                            </Col>
                            <Col span={12}>
                                <span className='title'>仓库联系人 : </span>
                                <span className='address-detail'>{this.state.contact}</span>
                            </Col>
                            <Col span={12}>
                                <span className='title'>仓库联系方式:</span>
                                <span className='address-detail'>{this.state.contactTel}</span>
                            </Col>
                        </Row>
                    </div>
                </div>
                {this.state.deliveryPlace2 != null ? <Fragment>
                    <div className="order-base-title">国内仓库信息2</div>
                    <div className="space-base-content">
                        <div className="base-info" style={{height: 'auto'}}>
                            <Row>
                                <Col span={12}>
                                    <span className='title'>仓库地址 : </span>
                                    <span className='address-detail'>{this.state.deliveryPlace2}</span>
                                </Col>
                                <Col span={12}>
                                    <span className='title'>仓库联系方式:</span>
                                    <span className='address-detail'>{this.state.contactTel2}</span>
                                </Col>
                                <Col span={12}>
                                    <span className='title'>仓库联系人 : </span>
                                    <span className='address-detail'>{this.state.contact2}</span>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Fragment> : null}
                <div className="order-base-title">
                    目的仓库信息(卸货仓)
                </div>
                <div className="space-base-content">
                    <div className="base-info" style={{height: 'auto'}}>
                        <Row>
                            <Col span={12}>
                                <span className='title'>仓库名称 : </span>
                                <span className='address-detail'>{this.state.consigneeName}</span>
                            </Col>
                            <Col span={12}>
                                <span className='title'>仓库地址:</span>
                                <span className='address-detail'>{this.state.consigneeAddr}</span>
                            </Col>
                            <Col span={12}>
                                <span className='title'>仓库联系人 : </span>
                                <span className='address-detail'>{this.state.consigneeContact}</span>
                            </Col>
                            <Col span={12}>
                                <span className='title'>仓库联系方式:</span>
                                <span className='address-detail'>{this.state.consigneePhone}</span>
                            </Col>
                            <Col span={24}>
                                <span className='title'>到货通知Notify:</span>
                                <span className='address-detail'>{this.state.arriveContact}</span>
                            </Col>
                        </Row>
                    </div>
                </div>
                <div className="order-base-title">
                    商品信息
                </div>
                <div className="order-goods-content">
                    <Table columns={columns} bordered dataSource={cabinPackageVoList} size="middle"
                           pagination={{
                               current: page,
                               pageSize: pageSize ? pageSize : 20,
                               total: total,
                               pageSizeOptions: ['20', '50', '100'],
                               showSizeChanger: true,
                               onShowSizeChange: (page, pageSize) => {
                                   this.goods(orderId, page, pageSize);
                               },
                               onChange: (page, pageSize) => {
                                   this.goods(orderId, page, pageSize);
                               },
                           }}/>
                </div>
                <SpaceModel
                    previewVisiable={this.state.previewVisiable}
                    hideModal={ this.previewhideModal }
                    previewData={this.state.previewData}
                />
                <Form.Item className="order-track-opt">
                    {/*<Button type='primary' onClick={this.downloadPdf}>下载</Button>*/}
                    {/*   <Button type='primary' onClick={this.previewShowModal}>预览</Button>*/}
                </Form.Item>
            </Form>
        )
    }
}
const WrappedOrderSpaceForm = Form.create()(OrderSpaceView);
export default  WrappedOrderSpaceForm;